import * as R from 'ramda'
import { hasValue } from '.'

export const getEnvVariable = (variable: string, fallback: any = null) => {
  // @ts-ignore
  const globalENV = window.env || {}
  const value = R.propOr(fallback, variable, globalENV)
  return hasValue(value) ? value : fallback
}
